import { render, staticRenderFns } from "./customerAll.vue?vue&type=template&id=5cc252bb&scoped=true&"
import script from "./customerAll.vue?vue&type=script&lang=js&"
export * from "./customerAll.vue?vue&type=script&lang=js&"
import style0 from "./customerAll.vue?vue&type=style&index=0&id=5cc252bb&prod&lang=css&"
import style1 from "./customerAll.vue?vue&type=style&index=1&id=5cc252bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc252bb",
  null
  
)

export default component.exports